import { IonButton, IonNav, IonText, useIonModal } from '@ionic/react'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import styled from 'styled-components'
import { LOADING_STATUS, isLoaded, amountString, ResWebSocket } from '../../../common'
import { CustomSpacer, FooterButtons } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { TradeOrderModal } from './modals/TradeOrderModal'

import { SingleSubStore } from '../../../store/subStore'

type Props = {
  payload: ResWebSocket | LOADING_STATUS
  // detailData: ResProductDetail | LOADING_STATUS
  detailStore: SingleSubStore<any>
}

export const TradeOrderbook: React.FC<Props> = observer(({ payload, detailStore }) => {
  const { authStore } = useContext(StoresContext)
  const [currentCost, setCurrentCost] = useState<number | undefined>(undefined)

  const getTradeOrderModal = (orderType: 'BUY' | 'SELL') =>
    isLoaded(detailStore) && (
      <TradeOrderModal
        productData={detailStore.content}
        currentCost={currentCost}
        orderType={orderType}
        onDismiss={() => {
          setCurrentCost(undefined)
          orderType === 'BUY' ? buyDismiss() : sellDismiss()
        }}
      />
    )

  /* 구매하기 모달 */
  const [buyPresent, buyDismiss] = useIonModal(<IonNav root={() => getTradeOrderModal('BUY')}></IonNav>, {})
  /* 판매하기 모달 */
  const [sellPresent, sellDismiss] = useIonModal(<IonNav root={() => getTradeOrderModal('SELL')}></IonNav>, {})

  const onOpenTradeModal = (isSell: boolean, cost?: number) => {
    if (cost != null) {
      setCurrentCost(cost)
    }
    if (isSell) {
      return sellPresent()
    }
    return buyPresent()
  }

  return (
    <>
      <CustomSpacer spacing="25px" />
      <OrderContainer>
        <table>
          <colgroup>
            <col width={'33%'} />
            <col width={'34%'} />
            <col width={'33%'} />
          </colgroup>
          <TbodyContract>
            {isLoaded(payload) &&
              payload.orders.map((p, i) => (
                <tr key={i}>
                  <StyleTdRight>{p.isSell ? <p>{amountString(String(p.count))}</p> : null}</StyleTdRight>
                  <StyleTdCenter isUp={p.isSell ? true : false}>
                    <IonButton fill={'clear'} onClick={() => onOpenTradeModal(!p.isSell, p.cost)}>
                      <IonText style={payload.currentCost === p.cost ? { color: '#000000' } : {}}>
                        {amountString(String(p.cost))}{' '}
                      </IonText>
                    </IonButton>
                  </StyleTdCenter>
                  <StyleTdLeft>{p.isSell ? null : <p>{amountString(String(p.count))}</p>}</StyleTdLeft>
                </tr>
              ))}
          </TbodyContract>
        </table>
      </OrderContainer>
      <CustomSpacer spacing="25px" />
      <StyleFooter>
        {authStore.userInfo == null ? (
          <FooterButtons
            button={{
              color: 'dark',
              text: '로그인하기',
              link: '/signIn',
            }}
          />
        ) : (
          <FooterButtons
            button={{ color: 'danger', text: '판매하기', onClick: () => onOpenTradeModal(true, undefined) }}
            rightButton={{ color: 'primary', text: '구매하기', onClick: () => onOpenTradeModal(false, undefined) }}
          />
        )}
      </StyleFooter>
      <CustomSpacer spacing="100px" />
    </>
  )
})

const OrderContainer = styled.section`
  display: flex;
  justify-content: center;
  font-size: 15px;
  table {
    width: 100%;
    text-align: center;
  }
`

const TbodyContract = styled.tbody`
  p {
    margin: 0;
  }
`

const StyleTdLeft = styled.td`
  text-align: start;
  p {
    font-weight: bold;
    margin-top: 5px;
  }
`

const StyleTdCenter = styled.td<{
  isUp?: boolean
}>`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 5px;
  cursor: pointer;
  ion-button {
    color: ${(p) => (p.isUp ? '#428cff' : '#ff4961')};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 30px;
    border-radius: 7px;
    background-color: ${(p) => (p.isUp ? '#ebf3fe' : '#fdedec')};
    font-size: 15;
    font-weight: bold;
    ion-text {
      font-size: 15px;
    }
  }
`

const StyleTdRight = styled.td`
  text-align: end;
  p {
    font-weight: bold;
    margin-top: 5px;
  }
`

const StyleFooter = styled.div`
  background-color: var(--ion-color-white);
  position: fixed;
  height: 85px;
  width: 100%;
  bottom: 0px;
`
